// export function generateAsyncComponents(basePath = '@/pages') {
//   const context = require.context(basePath, true, /\.vue$/);
//   const asyncComponents = {};
  
//   context.keys().forEach((key) => {
//     const componentName = key.replace(/^\.\//, '').replace(/\.\vue$/, '');  
//     // 使用正则表达式或其他逻辑来确保生成的组件名符合你的要求  
//     if (/^[A-Z]\w+$/.test(componentName)) { // 假设组件名以大写字母开头  
//       asyncComponents[componentName] = () => import(`${basePath}/${key}`).then(component => component.default); // 使用 import() 语法  
//     }  
//   });
  
//   return asyncComponents;  
// }

export function calculateCustomZIndex() {
  let windowHosts = document.querySelectorAll('.windowHost')

  // 初始化一个数组来存储所有的 z-index 值
  let zIndexValues = []

  windowHosts.forEach((windowHost) => {
    // 找到 windowHost 下的所有 .el-dialog__wrapper
    let dialogWrappers = windowHost.querySelectorAll('.el-dialog__wrapper')
    // 遍历这些 dialogWrappers
    dialogWrappers.forEach((dialogWrapper) => {
      // 尝试获取 z-index 值，如果未设置则默认为 'auto'
      let zIndex = window.getComputedStyle(dialogWrapper).zIndex
      // 过滤掉 'auto' 值，因为我们需要数字来比较
      if (zIndex !== 'auto') {
        // 将 z-index 转换为数字（如果它是 'initial' 或其他非数字值，这里可能需要额外的处理）
        let parsedZIndex = parseInt(zIndex, 10)
        if (!isNaN(parsedZIndex)) {
          zIndexValues.push(parsedZIndex)
        }
      }
    })
  })
  // 排序 z-index 值数组
  zIndexValues.sort((a, b) => b - a) // 降序排序，以便获取最大的 z-index
  // 根据最大的 z-index 值设置 customZIndex，通常我们会加一个值以确保新的弹窗始终在最上层
  return zIndexValues[0] ? zIndexValues[0] + 1 : 2500; // 假设默认从 1000 开始
}


export function calculateWinZIndex(className) {
  let windowHosts = document.querySelectorAll(className)
  let zIndexValues = []

  windowHosts.forEach((windowHost) => {
    let zIndex = window.getComputedStyle(windowHost).zIndex
    if (zIndex !== 'auto') {
      // 将 z-index 转换为数字（如果它是 'initial' 或其他非数字值，这里可能需要额外的处理）
      let parsedZIndex = parseInt(zIndex, 10)
      if (!isNaN(parsedZIndex)) {
        zIndexValues.push(parsedZIndex)
      }
    }
  })
  zIndexValues.sort((a, b) => b - a)
  return zIndexValues[0] ? zIndexValues[0] + 1 : 3000; // 假设默认从 1000 开始
}




// WEBPACK FOOTER //
// ./src/lib/utils.js